import { render, staticRenderFns } from "./ClassAttendanceForm.vue?vue&type=template&id=83e5d5f6&scoped=true"
import script from "./ClassAttendanceForm.vue?vue&type=script&lang=js"
export * from "./ClassAttendanceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e5d5f6",
  null
  
)

export default component.exports